import { useEffect } from "react";

const useAuthRedirect = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('userToken');

    if (token) {
      // Save the token
      localStorage.setItem('userToken', token);

      // Redirect to dashboard
      window.location.href = '/trading';
    }
  }, []);
};

export default useAuthRedirect;